import { TRPCGet, TRPCPost } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { TapdInfoType } from '@/presentation/components/tapd-info/edit-tapd-modal';
import { CustomFieldsType } from '@/presentation/components/tapd/create-tapd-modal';
import { Zone } from '@/proto/field';
import {
  IAddTapdInfoReq,
  IAddTapdInfoResp,
  IBindTapdIssueReq,
  IBindTapdIssueRsp,
  ICreateTapdIssueReq,
  ICreateTapdIssueRsp,
  IDeleteTapdInfoReq,
  IDeleteTapdInfoResp,
  IGetCustomFieldsReq,
  IGetCustomFieldsResp,
  IGetIssueTapdTemplateInfosReq,
  IGetIssueTapdTemplateInfosRsp,
  IGetTapdInfoReq, IGetTapdInfoResp,
  IReleaseTapdIssueReq,
  IReleaseTapdIssueRsp,
  ISaveIssueTapdTemplateInfosReq,
  ISaveIssueTapdTemplateInfosRsp,
  ITapdTemplateInfos,
} from '@/proto/manage';

export interface BaseRsp {
  status: 'ok' | 'error';
  baseRsp: {
    code: number;
    msg: string;
  };
  base_rsp: {
    code: number;
    msg: string;
  };
}


export interface TapdInfo {
  id: string;
  product_id: string;
  access_token: string;
  token_type: string;
  workspace_id: string;
  workspace_name: string;
  creator: string;
}


export interface TapdInfoRsp extends BaseRsp {
  tapd_infos: TapdInfo[];
}

export interface AddTapdInfoReq {
  code: string;
  redirect_uri: string;
  product_id: string;
  creator: string;
}

export interface CreateTapdIssueReq {
  product_id: string;
  type: Zone;
  issue_key: string;
  work_space_id: string;
  field_values: Record<string, any>[];
  remark?: string;
  monitor_type: Zone;
}

export interface BindTapdIssueReq {
  product_id: string;
  type: Zone;
  issue_key: string;
  tapd_id: string;
  work_space_id: string;
}

export interface ReleaseTapdIssueReq {
  product_id: string;
  type: Zone;
  issue_key: string;
}

export interface GetIssueTapdTemplateInfoReq {
  product_id: string;
  work_space_id: string;
}


export interface TapdTemplateInfos {
  creator: string;
  template_id: string;
  template_name: string;
  data: TapdInfoType[];
}


/** 获取tapd列表 */
export const getTapdList = async (productId: string): Promise<IGetTapdInfoResp | undefined> => {
  const params: IGetTapdInfoReq = {
    productId,
  };
  try {
    return await TRPCGet<TapdInfoRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/GetTapdInfo`, { params });
  } catch (e) {
    return undefined;
  }
};

/** 关联tapd信息 */
export const setTapdInfo = async (params: IAddTapdInfoReq): Promise<IAddTapdInfoResp | undefined> => {
  try {
    return await TRPCPost<IAddTapdInfoResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/AddTapdInfo`, params);
  } catch (e) {
    return undefined;
  }
};

/** 删除tapd信息 */
export const deleteTapdInfo = async (ids: number[]): Promise<IDeleteTapdInfoResp | undefined> => {
  const params: IDeleteTapdInfoReq = {
    ids,
  };
  try {
    return await TRPCPost<IDeleteTapdInfoResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/DeleteTapdInfo`, params);
  } catch (e) {
    return undefined;
  }
};

/** 创建tapd派单 TRPC 路径 */
export const CREATE_TAPD_ISSUE_URL = `/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/CreateTapdIssue`;

/** 创建tapd派单 */
export const createTapdIssue = async (params: ICreateTapdIssueReq): Promise<ICreateTapdIssueRsp | undefined> => {
  try {
    return await TRPCPost<ICreateTapdIssueRsp>(
      CREATE_TAPD_ISSUE_URL,
      params,
      { ignoreError: true },
    );
  } catch (e) {
    return undefined;
  }
};

/** 绑定已有tapd单 **/
export const bindTapdIssue = async (params: IBindTapdIssueReq): Promise<IBindTapdIssueRsp | undefined> => {
  try {
    return await TRPCPost<IBindTapdIssueRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/BindTapdIssue`, params);
  } catch (e) {
    return undefined;
  }
};

/** 解除已关联tapd单 **/
export const releaseTapdIssue = async (params: IReleaseTapdIssueReq): Promise<IReleaseTapdIssueRsp | undefined> => {
  try {
    return await TRPCPost<IReleaseTapdIssueRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTrack/ReleaseTapdIssue`, params);
  } catch (e) {
    return undefined;
  }
};

/** 获取tapd模版基本信息 woa **/
export const getIssueTapdInfos = async (params: IGetIssueTapdTemplateInfosReq): Promise<ITapdTemplateInfos[]> => {
  const emptyList = [
    {
      creator: '',
      template_id: '',
      template_name: '',
      data: [],
    },
  ];
  try {
    const res = await TRPCPost<IGetIssueTapdTemplateInfosRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTapdTemplate/GetIssueTapdTemplateInfos`, params);
    return res.infos || emptyList;
  } catch (e) {
    return emptyList;
  }
};

/** 保存tapd模板基本信息 woa **/
export const saveIssueTapdInfos = async (params: ISaveIssueTapdTemplateInfosReq):
Promise<number | null | undefined> => {
  try {
    const res = await TRPCPost<ISaveIssueTapdTemplateInfosRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.IssueTapdTemplate/SaveIssueTapdTemplateInfos`, params);
    return res?.templateId;
  } catch (e) {
    return undefined;
  }
};


/** 获取某个bug单的自定义字段 **/
export const getCustomFields = async (workspaceId: string): Promise<CustomFieldsType[]> => {
  const params: IGetCustomFieldsReq = {
    workspaceId,
  };
  try {
    const res = await TRPCPost<IGetCustomFieldsResp>(`/${API_PREFIX}/trpc/trpc.rmonitor.manage_server.Tapd/GetCustomFields`, params);
    return res.customFields?.map((item: any) => ({
      name: item.name,
      label: item.label,
      options: item.options,
      type: !!item.options.length ? 'select' : 'input',
    })) || [];
  } catch (e) {
    return [];
  }
};
